import { combineReducers } from 'redux';

//updateCount: subCategoryActions.updateCount,
//updateMyIcons: subCategoryActions.updateMyIcons,
//updateCurrentIcon: subCategoryActions.updateCurrentIcon,
//updateFilteredPacks: subCategoryActions.updateFilteredPacks,
//updateBreadCrumbs: subCategoryActions.updateBreadCrumbs,
//appendToBreadCrumbs: subCategoryActions.appendToBreadCrumbs,
//removeFromBreadCrumbs: subCategoryActions.removeFromBreadCrumbs,
//updateSymbologyJson: subCategoryActions.UPDATE_SYMBOLOGY_JSON,
//updateSubcatView: subCategoryActions.updateSubcatView

// count: 0,
// myIcons: [],
// packIndex: 0,
// currentIcon: {},
// filteredPacks: [],
// breadcrumbs: [{ text: 'Symbology ', link: '#/' }],
// symbologyJson: { packs: [] },
// subcatView: 'grid'
const initialState = {
  count: 0,
  myIcons: [],
  packIndex: 0,
  currentIcon: {},
  filteredPacks: [],
  breadcrumbs: [{ text: 'Symbology ', link: '#/' }],
  symbologyJson: { packs: [] },
  subcatView: 'grid'
};

const count = (state = initialState.count, action) => {
  switch (action.type) {
    //updateCount
    case 'UPDATE_COUNT':
      return action.payload;
    default:
      return state;
  }
};
const myIcons = (state = initialState.myIcons, action) => {
  switch (action.type) {
    //updateMyIcons
    case 'UPDATE_MY_ICONS':
      let myIcons = state.slice(0);
      const itemObj = action.payload;
      if (itemObj.isAdd) {
        if (!myIcons.some(icon => icon.path === itemObj.item.path)) {
          myIcons.push(itemObj.item);
        }
      } else {
        if (itemObj.item != null) {
          for (let i = 0; i < myIcons.length; i++) {
            if (itemObj.item.id === myIcons[i].id) {
              myIcons.splice(i, 1);
            }
          }
        } else {
          myIcons = [];
        }
      }
      return myIcons;
    default:
      return state;
  }
};
const currentIcon = (state = initialState.currentIcon, action) => {
  switch (action.type) {
    //updateCurrentIcon
    case 'UPDATE_CURRENT_ICON':
      return action.payload;
    default:
      return state;
  }
};
const filteredPacks = (state = initialState.filteredPacks, action) => {
  switch (action.type) {
    //updateFilteredPacks
    case 'UPDATE_FILTERED_PACKS':
      return action.payload;
    default:
      return state;
  }
};
const breadcrumbs = (state = initialState.breadcrumbs, action) => {
  switch (action.type) {
    //updateBreadCrumbs
    //appendToBreadCrumbs
    //removeFromBreadCrumbs
    case 'UPDATE_BREAD_CRUMBS':
      return action.payload;
    case 'APPEND_TO_BREAD_CRUMBS':
      return state.concat(action.payload);
    case 'REMOVE_FROM_BREAD_CRUMBS':
      const newPos = action.payload;
      return state.slice(0, newPos + 1);
    default:
      return state;
  }
};
const symbologyJson = (state = initialState.symbologyJson, action) => {
  switch (action.type) {
    //updateSymbologyJson
    case 'UPDATE_SYMBOLOGY_JSON':
      const regex = RegExp(/\(([^\)]+)\)$/);
      const symbology = action.payload;
      symbology.packs.forEach(pack => {
        pack.subpacks.forEach(subpack => {
          if (subpack.icons.every(item => regex.test(item.layer))) {
            const groups = {};
            subpack.icons.forEach(icon => {
              const base = icon.layer.replace(regex, '').trim();
              const iconDetails = icon.layer.match(regex)[1];

              if (!groups[base]) {
                groups[base] = {
                  details: []
                };
              }
              groups[base].details.push({
                iconType: iconDetails,
                path: icon.path,
                id: icon.id
              });
            });
            subpack.groups = groups;
          }
        });
      });
      return symbology;
    default:
      return state;
  }
};
const subcatView = (state = initialState.subcatView, action) => {
  switch (action.type) {
    //updateSubcatView
    case 'UDPATE_SUBCAT_VIEW':
      return action.payload;
    default:
      return state;
  }
};

export default combineReducers({
  count,
  myIcons,
  currentIcon,
  filteredPacks,
  breadcrumbs,
  symbologyJson,
  subcatView
});



// WEBPACK FOOTER //
// ./src/js/stores/reducers.js